<script>
    export default {
        name: "PromocodeBanner",
    };
</script>

<template>
    <div class="promocode-banner">
        <div class="promocode-banner__text">
            <h1 class="promocode-banner__title promocode__title">
                <span>Секретная страница скидок и промокодов</span> для покупок на сайте
                xd-design.ru
            </h1>
            <p class="promocode-banner__desc">
                Искали промокод на покупку противокражных рюкзаков Bobby? Вы нашли его! На
                секретной странице мы собрали специальные скидки на все модели. Выбирайте
                понравившийся рюкзак — и вперед, за выгодными покупками на сайте xd-design.ru
            </p>
        </div>
        <div class="promocode-banner__image">
            <img src="/static/xd-design/promocode/promocode-banner.gif" alt="" />
        </div>
    </div>
</template>

<style lang="scss">
    .promocode-banner {
        margin: 32px auto 24px;

        @include bp($bp-desktop-sm) {
            min-height: 234px;
            margin: 52px auto 30px;
            display: flex;
            justify-content: space-between;
        }
    }

    .promocode-banner__title {
        margin-bottom: 12px;

        @include bp($bp-desktop-sm) {
            max-width: 842px;
            margin-bottom: 16px;
        }
    }

    .promocode-banner__desc {
        font-weight: 300;
        font-size: 14px;
        line-height: 28px;
        color: var(--primary-text);

        @include bp($bp-desktop-sm) {
            max-width: 728px;
            font-size: 16px;
            line-height: 26px;
        }
    }

    .promocode-banner__image {
        margin-top: 24px;
        max-width: 100%;

        @include bp($bp-desktop-sm) {
            margin-top: 0;
            max-width: 270px;
        }

        @include bp($bp-desktop-md) {
            margin-right: 64px;
        }

        img {
            margin: 0 auto;
        }
    }
</style>
